<div class="dropdown-wrap pos-relative">
    <!-- in parent container use <ng-container class="dropdown-link">Link Text</ng-container> -->
    <a (click)="toggleDropdown()"><ng-content select=".dropdown-label"></ng-content><span class="txt-underline"><ng-content select=".dropdown-link"></ng-content></span></a>
    <div class="dropdown" [ngClass]="{'hide-fully': dropdownHidden }" (click)="toggleDropdown()">    
        <ul>
            <ng-content></ng-content>
        </ul>
    </div>
</div>